import React, { useEffect, useState } from 'react';
import { map } from 'rxjs';

import PanelIconTitle from '@/components/common/PanelIconTitle/PanelIconTitle';
import IgnoreStatusContainer from './IgnoreStatusAction/IgnoreStatus.container';
import { UsageLineSelectionPayload, variableLinesSelectionObservable } from
  '../UsageDetails/usageDetailsSelectionObservable';
import { SelectedRow } from '@/pages/ContractLines/hooks/useGridSelectionSubscription';
import ExportToExcelContainer from './ExportToExcel/ExportToExcel.container';
import styles from './actions.module.scss';
import { VarBillingUsageDetailStatusEnum, } from '@/graphql/contracts/_generated_/contracts';
import { useGetUserRole } from '@/hooks/identity/useGetUserRole';
import { UserRole } from '@/config/roles.config';
import { TabKeys } from '../../types';
import RestoreStatusContainer from './RestoreStatusAction/RestoreStatus.container';
import useGetUsageHeaderFromCache from '../hooks/useGetUsageHeaderFromCache.hook';
import { restoreHeaderStatuses } from '../helpers/getUsageDetailsHelpers';

interface IActionsContainer {
  onExcelExport: () => void;
  onIgnoreOrRestoreAction: (tabName: TabKeys) => void
}
export default function ActionsContainer({ onExcelExport, onIgnoreOrRestoreAction }: IActionsContainer) {
  const [selectedUsageDetails, setSelectedUsageDetails] =
    useState<SelectedRow<UsageLineSelectionPayload>[]>([]);
  const selectedRecordsContainIgnored = selectedUsageDetails.every(line =>
    line.payload.usageDetailsLine.status === VarBillingUsageDetailStatusEnum.Ignored);
  const { getUserRole } = useGetUserRole();
  const [userRole, setUserRole] = useState<UserRole>();
  const usageHeader = useGetUsageHeaderFromCache();
  const fullAccessRole = userRole === UserRole.FULL_ACCESS;
  const isUserRole = userRole === UserRole.USER;
  const isReaderRole = userRole === UserRole.READER;
  const isRestrictedRole = isUserRole || isReaderRole;
  const headerStatusApplicableForRestoreAction = usageHeader?.status &&
    restoreHeaderStatuses.includes(usageHeader.status);
    
  useEffect(() => {
    const subscription = variableLinesSelectionObservable
      .pipe(map((event) => event.selectedGridRows))
      .subscribe({
        next: (data) => setSelectedUsageDetails(data)
      });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    const getRole = async () => { 
      const roleName = await getUserRole();
      setUserRole(roleName);
    };
        
    getRole();
  }, [getUserRole]);

  return (
    <>
      <div className="mb-20 mt-20 ml-5">
        <PanelIconTitle>Actions</PanelIconTitle>
      </div>
      <div className={styles['actions-container']}>
        <ExportToExcelContainer onExcelExport={onExcelExport} />
        {selectedUsageDetails.length > 0 && !isRestrictedRole && (
          <IgnoreStatusContainer
            selectedUsageDetails={selectedUsageDetails}
            onIgnoreAction={onIgnoreOrRestoreAction}
          />
        )}
        {selectedRecordsContainIgnored && fullAccessRole && headerStatusApplicableForRestoreAction && (
          <RestoreStatusContainer
            selectedUsageDetails={selectedUsageDetails}
            onRestoreAction={onIgnoreOrRestoreAction}
          />

        )}
      </div>
    </>
  );
}
